import { atom } from 'recoil';

export const selfAffiliateCodeAtom = atom<string | null | undefined>({
  key: 'selfAffiliateCode',
  default: undefined,
});
